import { targets, targetable } from '@github/catalyst/lib/targetable'

export default targetable(class extends HTMLElement {
  static [targets.static] = ['links', 'panels']

  connectedCallback () {
    this.activateRail(0)

    this.observer = new IntersectionObserver((entries) => {
      if (this.suppressObserver) return

      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.activateRail(this.panels.indexOf(entry.target))
        }
      })
    }, { rootMargin: '-20% 0px -80% 0px', threshold: 0 })

    this.panels.forEach((p) => this.observer.observe(p))

    this.links.forEach((a, i) => {
      a.addEventListener('click', (e) => {
        e.preventDefault()
        this.suppressObserver = true
        this.activateRail(i)
        this.scrollToPanel(i, 'smooth')
        history.replaceState(null, '', a.hash)
        window.addEventListener('scrollend', () => { this.suppressObserver = false }, { once: true })
      })
    })

    this.maybeInitFromUrlHash()
  }

  disconnectedCallback () {
    this.observer.disconnect()
  }

  activateRail (idx) {
    this.links.forEach((a, i) => {
      a.toggleAttribute('data-active', i === idx)
    })
  }

  scrollToPanel (idx, behavior) {
    const panel = this.panels[idx]
    const padTop = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0
    const rect = panel.getBoundingClientRect()
    const top = window.scrollY + rect.top - padTop + 10

    window.scrollTo({ top, behavior })
  }

  maybeInitFromUrlHash () {
    const hash = window.location.hash.slice(1)

    if (!hash) return

    const idx = this.panels.findIndex((p) => p.dataset.panel === hash)

    if (idx < 0) return

    requestAnimationFrame(() => this.scrollToPanel(idx, 'auto'))
  }
})
